import { Coordinates } from "@hermes/api-model-common";

/**
 * Calculate the distance in metres between two coordinate pairs
 *
 * @param from where we are located
 * @param to where we want to go
 */
export const calculateDistance = (
    from: Coordinates,
    to: Coordinates,
): number => {
    const rad = (x: number) => (x * Math.PI) / 180;

    // Calculate the distance in metres between two coordinate pairs
    const R = 6_378_137; // Earth’s mean radius in metres
    const dLat = rad(to.latitude - from.latitude);
    const dLong = rad(to.longitude - from.longitude);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(rad(from.latitude)) *
            Math.cos(rad(to.latitude)) *
            Math.sin(dLong / 2) *
            Math.sin(dLong / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
};
